var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page_data)?_c('div',[_c('b-row',[_c('b-col',{attrs:{"offset-md":"9","md":"3"}},[_c('div',{staticClass:"info total-info"},[_c('ul',[_c('hr'),_c('li',[_vm._v(" "+_vm._s(_vm.page_data.sub_total)+" SAR ")])])])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }